export var CadClickServiceMode;
(function (CadClickServiceMode) {
    CadClickServiceMode["WebApi"] = "webApi";
    CadClickServiceMode["Next"] = "N3XT";
})(CadClickServiceMode || (CadClickServiceMode = {}));
export const CAD_CLICK_VIEWER_3D_DEFAULT_PROPS = {
    cadClickWebApiUrl: "",
    cadClickApiKey: "",
    cadClickModel: {},
    assemblyModel: {},
    serviceMode: CadClickServiceMode.WebApi,
    app: {
        useLocalStorage: false,
        fileFormat: "gltf",
    },
    ui: {
        loading: {
            enabled: false, // creates an overlay that interferes with the other content
        },
        theme: "light",
    },
    camera: {
        type: "perspective",
        applyDefaultViewAfterLoad: true,
        initialView: 15,
        defaultView: 15,
    },
    controls: {
        updateTarget: false,
    },
    services: {
        webApi: {
            url: "",
            apiKey: "",
            cacheOutput: true,
        },
    },
    tools: {},
    materialLibrary: {},
    scene: {},
    translation: {},
    viewer3DOptions: {},
    viewLevel: 1,
    loadMode: "instanceList",
    loadCameraHack: false,
    style: {
        minHeight: "720px",
        maxHeight: "min(100%,100vh)",
    },
};
//# sourceMappingURL=CadClickViewer3DProps.js.map